<script>
export default {
  name: "base-button",
  props: {
    label: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  },
}
</script>

<template>
  <v-btn elevation="0" color="#0AAC5F" block class="base-button" @click="handleClick">{{label}}</v-btn>
</template>

<style scoped lang="less">
.base-button{
  padding: 0.75rem 1rem !important;
  height: unset !important;
  border-radius: 0.75rem;
  :deep{
    .v-btn__content{
      color: #FFF;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.5rem;
    }
  }
}
</style>